import React, { useState } from 'react';
import { formatDateYear } from '@services';
import VideoCard from './VideoCard';
import ChdTvDropdown from '../Buttons/ChdTvDropdown';

type Props = {
  lang: string,
  stringTranslations: any,
  videos: any[],
}

function AllVideos({ lang, videos, stringTranslations } : Props) {
  const currentYear = new Date().getFullYear();
  const showYears: { year: number, isCurrent: boolean}[] = [];
  let currentShowYear = new Date().getFullYear();
  if (videos) {
    const videosByYear: { year: number, video: any }[] = videos
      .reduce((
        accVideo: { year: number, video: any }[],
        currentVideo: any,
      ) => {
        const videoYear = formatDateYear(currentVideo.publishDate || currentVideo.createdAt)!;
        accVideo.push(
          {
            year: videoYear,
            video: currentVideo,
          },
        );
        return accVideo;
      }, [])
      .reduce((
        acc: { [key: number]: any[] },
        currentValue: any,
      ) => {
        if (!acc[currentValue.year]) {
          acc[currentValue.year] = [];
        }
        acc[currentValue.year].push(currentValue.video);
        return acc;
      }, {});
    const videoYears = Object.keys(videosByYear)
      .map((key) => parseInt(key, 10))
      .reverse();
    currentShowYear = Math.max(...videoYears);
    showYears.push(
      ...videoYears
        .map((year: number) => ({ year, isCurrent: year === currentShowYear })),
    );
  }

  const showYear = showYears.find((sy) => sy.isCurrent)?.year;
  const [selectedYear, setSelectedYear] = useState(showYear ?? currentYear);
  const handleYearSelect = (year: number) => {
    setSelectedYear(year);
  };

  return (
    <div>
      {videos && (
      <div className="flex items-center justify-between my-4 uppercase px-2.5">
        <p className="font-bold uppercase text-[24px] text-chdGreen-light leading-[26.5px] tracking-widest">All</p>
        <ChdTvDropdown
          selectYear={handleYearSelect}
          currentYear={selectedYear}
          lang={lang}
          showYears={showYears}
          stringTranslations={stringTranslations}
        />
      </div>
      )}
      <div className="flex flex-wrap">
        {videos?.sort((a :any, b:any) => a.publishDate - b.publishDate)
          .map((video:any) => (video.showYear === selectedYear
            ? (
              <VideoCard
                key={video.id}
                video={video}
              />
            )
            : (null))) }
      </div>
    </div>
  );
}

export default AllVideos;
